import {type FC, useCallback, useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import type {BankAccount} from "../../../../hooks/wallet/useGetAccountPagoMovil";
import useGetAccountPagoMovil from "../../../../hooks/wallet/useGetAccountPagoMovil";
import {useBalanceStore} from "../../../../store/useBalance.store";
import {BaseSelect} from "../../../BaseSelect";
import parentStyles from "../WithdrawalSteps.module.css";
import WithdrawalLimits from "./WithdrawalLimits";

interface SelectAccountProps {
  setSelectBankAccount: (account: BankAccount) => void;
  setIsNextDisabled?: (disabled: boolean) => void;
}

const SelectAccount: FC<SelectAccountProps> = ({setSelectBankAccount, setIsNextDisabled}) => {
  const {options, getAccountById} = useGetAccountPagoMovil();
  const [selectedId, setSelectedId] = useState<number | null>(null);
  const handlePagoMovilListModal = useBalanceStore(state => state.handlePagoMovilListModal);
  const {t} = useTranslation();

  useEffect(() => {
    setIsNextDisabled?.(true);
  }, [setIsNextDisabled]);

  useEffect(() => {
    if (selectedId == null) return;
    const bankAccount = getAccountById(selectedId);
    if (bankAccount) setSelectBankAccount(bankAccount);
  }, [selectedId, getAccountById, setSelectBankAccount]);

  const handleChange = useCallback(
    (value: string | number) => {
      setSelectedId(value as number);
      setIsNextDisabled?.(false);
    },
    [setIsNextDisabled]
  );

  const handleKeyDown = useCallback(
    (e: React.KeyboardEvent) => {
      if (e.key === "Enter") handlePagoMovilListModal();
    },
    [handlePagoMovilListModal]
  );

  return (
    <div>
      <WithdrawalLimits />
      <div className={parentStyles.selectAccountSection}>
        <p className={parentStyles.selectAccountTitle}>{t("withdrawalStepsSelectAccount")}</p>
        <div className={parentStyles.selectAccountRow}>
          <BaseSelect
            options={options}
            placeholder={t("withdrawalStepsSelectAccount_select")}
            onChange={handleChange}
            searchable
            fullWidth
          />
        </div>
        <p className={parentStyles.selectAccountHint}>
          {t("withdrawalStepsSelectAccountDesc2")}
          <span
            className={parentStyles.selectAccountLink}
            onClick={handlePagoMovilListModal}
            role="button"
            tabIndex={0}
            onKeyDown={handleKeyDown}
          >
            {t("withdrawalStepsSelectAccountlink")}
          </span>
          .
        </p>
      </div>
    </div>
  );
};

export default SelectAccount;
